import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "kt_drawer_target_list",
  "data-kt-drawer": "true",
  "data-kt-drawer-activate": "true",
  "data-kt-drawer-name": "target_list",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-direction": "end",
  "data-kt-drawer-toggle": "#kt_drawer_target_list_button",
  "data-kt-drawer-close": "#kt_drawer_target_list_close",
  "data-kt-drawer-width": "50.5vw"
}
const _hoisted_2 = {
  id: "kt_target_list",
  class: "card shadow-none border-0",
  style: {"width":"72.5vw"}
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header bg-primary text-light\" id=\"kt_target_list_header\"><h2 class=\"fw-bolder text-light\">Edit Info</h2><div class=\"card-toolbar\"><button type=\"button\" class=\"btn btn-sm btn-icon btn-active-primary-light me-n5\" id=\"kt_drawer_target_list_close\"><i class=\"fas fa-times text-light\"></i></button></div></div>", 1)
const _hoisted_4 = {
  class: "card-body position-relative",
  id: "kt_target_list_body",
  "data-kt-scroll": "true",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-wrappers": "#kt_target_list_body",
  "data-kt-scroll-dependencies": "#kt_target_list_header, #kt_target_list_footer",
  "data-kt-scroll-offset": "5px"
}
const _hoisted_5 = { class: "position-relative" }
const _hoisted_6 = ["validation-schema"]
const _hoisted_7 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_target_list_scroll"
}
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-6" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = { class: "col-6" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = { class: "row mt-4" }
const _hoisted_16 = { class: "col-6" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Target Year From", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = { class: "col-6" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Target Year To", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = { class: "row mt-4" }
const _hoisted_23 = { class: "col-6" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Target Year Id", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = { class: "col-md-6" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Trainne Number", -1)
const _hoisted_28 = {
  class: "card-footer py-5 text-center",
  id: "kt_target_list_footer"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("button", {
  type: "reset",
  id: "kt_target_list_cancel",
  class: "btn btn-secondary me-5"
}, " Discard ", -1)
const _hoisted_30 = ["data-kt-indicator"]
const _hoisted_31 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_32 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_33 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_form, {
            onSubmit: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
            model: _ctx.formData,
            rules: _ctx.rules,
            ref: "formRef"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "card-body p-2",
                "validation-schema": _ctx.TargetListSchema
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _hoisted_11,
                      _createVNode(_component_el_form_item, { prop: "entity_type_id" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            class: "form-select-solid w-100",
                            placeholder: "Select Tranche",
                            modelValue: _ctx.formData.tranche_id,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.tranche_id) = $event))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranche, (trans) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: trans.id,
                                  label: trans.label,
                                  value: trans.id
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(trans.label), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "entity_type_id",
                        class: "fv-plugins-message-container invalid-feedback"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _hoisted_14,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        placeholder: "Select Partner",
                        modelValue: _ctx.formData.entity_info_id,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.entity_info_id) = $event)),
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.association, (data) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: data.id,
                              label: data.entity_short_name,
                              value: data.id
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(data.entity_name), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "entity_info_id",
                        class: "fv-plugins-message-container invalid-feedback"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      _hoisted_18,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        placeholder: "Select Year",
                        modelValue: _ctx.formData.target_year_from,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.target_year_from) = $event)),
                        filterable: "",
                        style: {"width":"100%"},
                        selected: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fromYear, (info) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: info,
                              label: info,
                              value: info
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(info), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _hoisted_20,
                      _hoisted_21,
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        placeholder: "Select Year",
                        modelValue: _ctx.formData.target_year_to,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.target_year_to) = $event)),
                        filterable: "",
                        style: {"width":"100%"},
                        selected: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.toYear, (info) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: info,
                              label: info,
                              value: info
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(info), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _hoisted_24,
                      _hoisted_25,
                      _createVNode(_component_el_form_item, { prop: "year_id " }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            class: "form-select-solid w-100",
                            placeholder: "Select Target year",
                            modelValue: _ctx.formData.target_year_id,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.target_year_id) = $event))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.targetYears, (info) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: info.id,
                                  label: info.name,
                                  value: info.id
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(info.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "target_year_id",
                        class: "fv-plugins-message-container invalid-feedback"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _hoisted_27,
                      _createVNode(_component_el_form_item, { prop: "traineeNumber" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.target_trainee_number,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.target_trainee_number) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "target_trainee_number",
                        class: "fv-plugins-message-container invalid-feedback"
                      })
                    ])
                  ])
                ])
              ], 8, _hoisted_6),
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createElementVNode("button", {
                  "data-kt-indicator": _ctx.loading ? 'on' : null,
                  class: "btn btn-lg btn-primary",
                  type: "submit",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.formSubmit()))
                }, [
                  (!_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_31, [
                        _createTextVNode(" Submit "),
                        _createElementVNode("span", _hoisted_32, [
                          _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_33, [
                        _createTextVNode(" Please wait... "),
                        _hoisted_34
                      ]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_30)
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ])), [
        [_directive_loading, _ctx.load]
      ])
    ])
  ]))
}